import React, { useState } from "react";
import "./css/settings.css";

const HelpPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const helpTopics = [
    {
      title: "Getting Started",
      content: "Learn how to navigate the system and access key features.",
      details: (
        <div>
          <p>To get started with the system:</p>
          <ol>
            <li>Log in using your NHS credentials</li>
            <li>Navigate using the menu on the left side</li>
            <li>Access patient records through the search function</li>
            <li>Use the quick actions toolbar for common tasks</li>
          </ol>
          <div className="video-container">
            <iframe width="560" height="315" 
            src="https://www.youtube.com/embed/iGFfhdSD8SU?si=J7gpFHH93evNpEUZ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
            </iframe>
          </div>
        </div>
      )
    },
    {
      title: "Patient Management",
      content: "How to add, edit, and manage patient records.",
      details: (
        <div>
          <p>Key patient management features:</p>
          <ul>
            <li>Search for patients using CHI number or name</li>
            <li>Add new patients through the registration form</li>
            <li>Update existing records with the edit function</li>
            <li>View full patient history in the details panel</li>
          </ul>
        </div>
      )
    },
    {
      title: "Appointment Scheduling",
      content: "Guide to booking and managing appointments.",
      details: (
        <div>
          <p>Appointment scheduling steps:</p>
          <ol>
            <li>Select the patient from your list</li>
            <li>Choose date and time from the calendar</li>
            <li>Select appointment type and duration</li>
            <li>Confirm with the patient and send reminders</li>
          </ol>
        </div>
      )
    },
    {
      title: "Reporting Issues",
      content: "How to report technical problems or bugs.",
      details: (
        <div>
          <p>To report an issue:</p>
          <ul>
            <li>Click the 'Help' button in the top navigation</li>
            <li>Select 'Report a Problem' from the menu</li>
            <li>Describe the issue in detail</li>
            <li>Include screenshots if possible</li>
            <li>Submit your report</li>
          </ul>
          <p>Our support team will respond within 24 hours.</p>
        </div>
      )
    },
    {
      title: "System Requirements",
      content: "Technical specifications and browser compatibility.",
      details: (
        <div>
          <h4>Minimum System Requirements:</h4>
          <table className="help-table">
            <thead>
              <tr>
                <th>Component</th>
                <th>Requirement</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Operating System</td>
                <td>Windows 10 or macOS 10.15+</td>
              </tr>
              <tr>
                <td>Browser</td>
                <td>Chrome 90+, Firefox 85+, Edge 90+</td>
              </tr>
              <tr>
                <td>Internet Connection</td>
                <td>Minimum 5Mbps recommended</td>
              </tr>
            </tbody>
          </table>
        </div>
      )
    }
  ];

  return (
    <div className="help-container">
      <div className="help-header">
        <h1>Help Centre</h1>
        <p>Find answers to common questions and learn how to use the system</p>
      </div>

      <div className="accordion">
        {helpTopics.map((topic, index) => (
          <div 
            key={index} 
            className={`accordion-item ${activeIndex === index ? 'active' : ''}`}
          >
            <button
              className="accordion-header"
              onClick={() => toggleAccordion(index)}
              aria-expanded={activeIndex === index}
              aria-controls={`accordion-content-${index}`}
            >
              <span className="accordion-title">{topic.title}</span>
              <span className="accordion-icon">
                {activeIndex === index ? '−' : '+'}
              </span>
            </button>
            <div
              id={`accordion-content-${index}`}
              className="accordion-content"
              style={{
                maxHeight: activeIndex === index ? '1000px' : '0',
                opacity: activeIndex === index ? '1' : '0'
              }}
            >
              <div className="accordion-body">
                <p className="accordion-summary">{topic.content}</p>
                <div className="accordion-details">{topic.details}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="help-footer">
        <p>Still need help? Contact our support team:</p>
        <button className="btn btn-primary">Contact Support</button>
      </div>
    </div>
  );
};

export default HelpPage;